import { Box, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { FunctionComponent, useEffect } from 'react';
import nervaLogoWithName from '../../assets/svgs/logos/nerva-logo-with-name.svg';
import { Analytics } from '../../helpers/analytics/Analytics';
import { AnalyticsEventName } from '../../helpers/analytics/AnalyticsEvent';
import { useAuthStore } from '../../store/AuthStore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    paddingBottom: '20px',
    paddingTop: `${theme.spacing(3)}px`,
    [theme.breakpoints.up('sm')]: {
      paddingTop: `${theme.spacing(8)}px`,
    },
  },
  card: {
    height: '100%',
    borderRadius: 30,
    padding: theme.spacing(3),
    '& .MuiCardHeader-title': { textAlign: 'center' },
  },
  cardGrid: { width: '100%' },
  listItemRoot: {
    paddingLeft: 0,
  },
}));

export const InvalidReferralLinkScreen: FunctionComponent = () => {
  const classes = useStyles();
  const type = useAuthStore((state) => state.referralUrlType);

  useEffect(function trackAnalytiics() {
    Analytics.track({
      event: AnalyticsEventName.h_referral_url_failed,
      type,
      error: 'invalid link',
    });
  }, []);

  return (
    <Container maxWidth="sm">
      <Grid container direction="column" alignItems="center" classes={{ root: classes.root }}>
        <Grid container item xs={12} direction="column" alignItems="center">
          <Box marginBottom="20px">
            <img src={nervaLogoWithName} alt="mindset health logo" width={220} height={93} />
          </Box>
        </Grid>
        <Grid container item xs={12} direction="column" justifyContent="center">
          <Box
            textAlign="center"
            justifyContent="center"
            display="flex"
            marginTop="46px"
            marginBottom="20px"
          >
            <Typography>
              Sorry! The link you’ve entered isn’t connected to a healthcare practitioner.
            </Typography>
          </Box>
        </Grid>
        <Grid container item xs={12} direction="column">
          <Box textAlign="center" justifyContent="center" display="flex">
            <Typography>Please try again or ask your team to send you a new one.</Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};
